import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-sale',
  templateUrl: './home-sale.component.html',
  styleUrls: ['./home-sale.component.scss']
})
export class HomeSaleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
